import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CreateOrderFromSMS from './CreateOrderFromSMS';

const API_URL = '/api';

const SMSParser = ({ onOrderCreated }) => {
  const [showOrderForm, setShowOrderForm] = useState(false);
  const [selectedSMS, setSelectedSMS] = useState(null);
  const [smsText, setSmsText] = useState('');
  const [parsed, setParsed] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [savedSMS, setSavedSMS] = useState([]);
  const [showSaved, setShowSaved] = useState(false);

  // Загрузка сохранённых SMS при старте
  useEffect(() => {
    loadSavedSMS();
  }, []);

  const loadSavedSMS = async () => {
    try {
      const response = await axios.get(`${API_URL}/saved-sms/list`);
      setSavedSMS(response.data);
    } catch (err) {
      console.error('Ошибка загрузки сохранённых SMS:', err);
    }
  };

  const handleParse = async () => {
    if (!smsText.trim()) {
      setError('Вставьте текст SMS');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${API_URL}/sms-parser/parse`, {
        sms_text: smsText
      });
      setParsed(response.data);
    } catch (err) {
      setError('Ошибка парсинга: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    if (!smsText.trim()) {
      setError('Вставьте текст SMS');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${API_URL}/saved-sms/save`, {
        sms_text: smsText
      });
      
      alert('✅ SMS сохранено! Можете создать заявку позже.');
      setSmsText('');
      setParsed(null);
      loadSavedSMS();
    } catch (err) {
      console.error('Save error:', err);
      let errorMsg = 'Ошибка сохранения';
      if (err.response?.data?.detail) {
        errorMsg += ': ' + JSON.stringify(err.response.data.detail);
      } else if (err.message) {
        errorMsg += ': ' + err.message;
      }
      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setSmsText('');
    setParsed(null);
    setError('');
  };

  const handleDeleteSaved = async (id) => {
    if (!window.confirm('Удалить эту SMS?')) return;

    try {
      await axios.delete(`${API_URL}/saved-sms/${id}`);
      loadSavedSMS();
    } catch (err) {
      alert('Ошибка удаления: ' + err.message);
    }
  };

  const handleCreateOrderFromSMS = async (sms) => {
    // Загружаем распарсенные данные
    try {
      const response = await axios.get(`${API_URL}/saved-sms/${sms.id}`);
      setSelectedSMS(response.data);
      setShowOrderForm(true);
    } catch (err) {
      alert('Ошибка загрузки: ' + err.message);
    }
  };

  const handleOrderCreated = () => {
    loadSavedSMS();
    if (onOrderCreated) onOrderCreated();
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h2>📱 Парсинг SMS для создания заявки</h2>
        <button 
          onClick={() => setShowSaved(!showSaved)} 
          style={styles.btnSaved}
        >
          💾 Сохранённые SMS ({savedSMS.length})
        </button>
      </div>
      
      <div style={styles.section}>
        <h3>Вставьте текст SMS:</h3>
        <textarea
          value={smsText}
          onChange={(e) => setSmsText(e.target.value)}
          placeholder="Скопируйте текст SMS сообщения сюда..."
          style={styles.textarea}
        />
        <div style={styles.buttons}>
          <button onClick={handleParse} disabled={loading} style={styles.btn}>
            {loading ? '⏳ Парсим...' : '🔍 Распарсить SMS'}
          </button>
          <button onClick={handleSave} disabled={loading} style={styles.btnSave}>
            💾 Создать позже
          </button>
          <button onClick={handleClear} style={styles.btnSecondary}>🗑️ Очистить</button>
        </div>
      </div>

      {error && (
        <div style={styles.errorBox}>{error}</div>
      )}

      {parsed && (
        <div style={styles.section}>
          <h3>✓ Результаты парсинга (уверенность: {Math.round(parsed.confidence * 100)}%):</h3>
          
          <table style={styles.table}>
            <tbody>
              <tr>
                <td style={styles.label}>📅 Дата заявки:</td>
                <td style={styles.value}>{parsed.date || '❌ не найдена'}</td>
              </tr>
              <tr>
                <td style={styles.label}>🎯 Номер точки:</td>
                <td style={styles.value}>{parsed.point_number || '❌ нет'}</td>
              </tr>
              <tr>
                <td style={styles.label}>🏢 Контрагент:</td>
                <td style={styles.value}>{parsed.counterparty || '❌ не определен'}</td>
              </tr>
              <tr>
                <td style={styles.label}>📍 Откуда:</td>
                <td style={styles.value}>{parsed.start_location || '❌ не указано'}</td>
              </tr>
              <tr>
                <td style={styles.label}>📍 Куда:</td>
                <td style={styles.value}>{parsed.end_location || '❌ не указано'}</td>
              </tr>
              <tr>
                <td style={styles.label}>⚖️ Вес, кг:</td>
                <td style={styles.value}>{parsed.weight_kg || '—'}</td>
              </tr>
              <tr>
                <td style={styles.label}>📦 Коробы:</td>
                <td style={styles.value}>{parsed.boxes || '—'}</td>
              </tr>
              <tr>
                <td style={styles.label}>📐 Объём, м³:</td>
                <td style={styles.value}>{parsed.volume_m3 || '—'}</td>
              </tr>
              <tr>
                <td style={styles.label}>🚛 Транспорт:</td>
                <td style={styles.value}>{parsed.shipping_company || '—'}</td>
              </tr>
            </tbody>
          </table>

          <div style={styles.manualSection}>
            <h4>⚠️ Дополните вручную:</h4>
            <p>Следующие поля нужно ввести вручную (не нашли в SMS):</p>
            <ul>
              <li>👨 Водитель (выбрать или создать)</li>
              <li>🚗 Автомобиль (выбрать или создать)</li>
              <li>💰 Цена доставки</li>
            </ul>
          </div>

          <button 
            style={styles.btnPrimary} 
            onClick={() => {
              // Открываем форму создания заявки с распарсенными данными
              setShowOrderForm(true);
              setSelectedSMS({ parsed, raw_text: smsText });
            }}
          >
            ✓ Создать заявку из SMS
          </button>
        </div>
      )}

      {/* Форма создания заявки из распарсенной SMS */}
      {showOrderForm && selectedSMS && (
        <CreateOrderFromSMS
          smsData={selectedSMS}
          onClose={() => {
            setShowOrderForm(false);
            setSelectedSMS(null);
          }}
          onSuccess={() => {
            setShowOrderForm(false);
            setSelectedSMS(null);
            setSmsText('');
            setParsed(null);
            alert('✅ Заявка создана!');
          }}
        />
      )}

      {/* Список сохранённых SMS */}
      {showSaved && (
        <div style={styles.savedSection}>
          <h3>💾 Сохранённые SMS</h3>
          {savedSMS.length === 0 ? (
            <p style={styles.empty}>Нет сохранённых SMS</p>
          ) : (
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>Дата сохранения</th>
                  <th style={styles.th}>Текст (начало)</th>
                  <th style={styles.th}>Статус</th>
                  <th style={styles.th}>Действия</th>
                </tr>
              </thead>
              <tbody>
                {savedSMS.map((sms) => (
                  <tr key={sms.id}>
                    <td style={styles.td}>
                      {new Date(sms.created_at).toLocaleDateString('ru-RU')}
                    </td>
                    <td style={styles.td}>{sms.full_text || sms.raw_text}</td>
                    <td style={styles.td}>
                      {sms.is_processed ? '✅ Обработано' : '⏳ Ожидает'}
                    </td>
                    <td style={styles.td}>
                      <button 
                        onClick={() => handleCreateOrderFromSMS(sms)}
                        style={styles.btnSmall}
                      >
                        📋 В заявку
                      </button>
                      <button 
                        onClick={() => handleDeleteSaved(sms.id)}
                        style={styles.btnSmallDel}
                      >
                        🗑️
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* Форма создания заявки из SMS */}
      {showOrderForm && selectedSMS && (
        <CreateOrderFromSMS
          smsData={selectedSMS}
          onClose={() => {
            setShowOrderForm(false);
            setSelectedSMS(null);
          }}
          onSuccess={handleOrderCreated}
        />
      )}
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '900px',
    margin: '0 auto',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
  },
  btnSaved: {
    padding: '10px 15px',
    background: '#5D396E',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: 'bold',
  },
  section: {
    background: '#fff',
    padding: '20px',
    marginBottom: '20px',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  textarea: {
    width: '100%',
    height: '150px',
    padding: '12px',
    border: '2px solid #0C7281',
    borderRadius: '5px',
    fontSize: '14px',
    fontFamily: 'monospace',
    boxSizing: 'border-box',
    marginBottom: '15px',
  },
  buttons: {
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap',
  },
  btn: {
    padding: '12px 20px',
    background: '#075A64',
    color: '#FEFEFA',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '16px',
  },
  btnSave: {
    padding: '12px 20px',
    background: '#5D396E',
    color: '#FEFEFA',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '16px',
  },
  btnSecondary: {
    padding: '12px 20px',
    background: '#ccc',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: 'bold',
  },
  btnPrimary: {
    padding: '12px 20px',
    background: '#0C7281',
    color: '#FEFEFA',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '16px',
    marginTop: '15px',
  },
  errorBox: {
    background: '#ffebee',
    color: '#c62828',
    padding: '15px',
    borderRadius: '5px',
    marginBottom: '15px',
    border: '1px solid #ef5350',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginBottom: '20px',
  },
  label: {
    padding: '10px',
    fontWeight: 'bold',
    background: '#f5f5f5',
    width: '30%',
    borderBottom: '1px solid #ddd',
  },
  value: {
    padding: '10px',
    borderBottom: '1px solid #ddd',
  },
  manualSection: {
    background: '#fff3cd',
    padding: '15px',
    borderRadius: '5px',
    borderLeft: '4px solid #ffc107',
    marginBottom: '15px',
  },
  savedSection: {
    background: '#fff',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  empty: {
    textAlign: 'center',
    color: '#999',
    padding: '20px',
  },
  btnSmall: {
    padding: '5px 10px',
    background: '#0C7281',
    color: '#fff',
    border: 'none',
    borderRadius: '3px',
    cursor: 'pointer',
    fontSize: '12px',
    marginRight: '5px',
  },
  btnSmallDel: {
    padding: '5px 10px',
    background: '#d32f2f',
    color: '#fff',
    border: 'none',
    borderRadius: '3px',
    cursor: 'pointer',
    fontSize: '12px',
  },
};

export default SMSParser;
